import { useState } from "react";
import GenericUploadInput from "../GenericUploadInput/GenericUploadInput.web";
import Icon from "../../icons/Icon.web";
import { DocumentUploadInputPropsType } from "./DocumentUploadInput.props";

const DocumentUploadInput = (props: DocumentUploadInputPropsType) => {
  const {
    setDocument,
    acceptedFileTypes = {
      "application/pdf": [".pdf"],
      "application/msword": [".doc"],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        [".docx"],
    },
  } = props;
  const [currentFile, setCurrentFile] = useState<File>();

  const updateCurrentFile = (input: File) => {
    setCurrentFile(input);
  };

  const onDrop = (fileList: File[]) => {
    const reader = new FileReader();
    reader.onload = (e) => setDocument(e.target?.result?.toString() ?? "");
    reader.readAsDataURL(fileList[0]);
    updateCurrentFile(fileList[0]);
  };

  return (
    <GenericUploadInput
      {...props}
      updateDocument={setDocument}
      acceptedFileTypes={acceptedFileTypes}
      currentFile={currentFile}
      updateCurrentFile={updateCurrentFile}
      dropzoneIcon={<Icon.Document boxSize="element.5xl" color="gray.400" />}
      removeButtonIcon={
        <Icon.Document color="gray.400" boxSize="element.4xl" />
      }
      onDrop={onDrop}
    />
  );
};

export default DocumentUploadInput;
